module.exports = __webpack_public_path__ + "img/short03.ba28bb77.jpg";